<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>呆账商品列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <div style="display: flex; flex-direction: row">
                  <div
                    style="
                      width: 180px;
                      line-height: 40px;
                      font-size: 14px;
                      color: #606266;
                    "
                  >
                    搜索条件:
                  </div>
                  <div>
                    <el-form-item label="">
                      <el-input
                        v-model="form.goods_no"
                        placeholder="商品货号"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.goods_name"
                        placeholder="商品名称"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.market_name"
                        placeholder="市场"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.supply_name"
                        placeholder="商家"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.city"
                        multiple
                        placeholder="商家城市"
                      >
                        <el-option
                          v-for="item in citys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.woid"
                        placeholder="代采单"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-select v-model="form.pgid" placeholder="代采组">
                        <el-option :key="0" value="0" label="全部"></el-option>
                        <el-option
                          v-for="item in resData.pgOption"
                          :key="item.value"
                          :value="item.value"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="">
                      <el-select
                        v-model="form.order_owner"
                        filterable
                        placeholder="订单负责人"
                      >
                        <el-option :key="0" value="0" label="全部"></el-option>
                        <el-option
                          v-for="item in resData.owner_option"
                          :key="item.value"
                          :value="item.value"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.operator"
                        placeholder="操作人"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-input
                        v-model="form.sku"
                        placeholder="sku"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-select v-model="form.source" placeholder="欠货来源">
                        <el-option :key="0" value="0" label="全部"></el-option>
                        <el-option value="100" label="代采欠货"></el-option>
                        <el-option value="1" label="退换货欠货"></el-option>
                        <el-option value="2" label="售后欠货"></el-option>
                        <el-option value="3" label="售后退供"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="">
                      <el-select
                        v-model="form.p_reason_id"
                        placeholder="一级原因"
                        @change="setReson"
                      >
                        <el-option
                          :key="0"
                          :value="'0'"
                          label="一级原因"
                        ></el-option>
                        <el-option
                          v-for="item in resData.reasonOption"
                          :key="item.reason_id"
                          :label="item.reason_name"
                          :value="item.reason_id"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-model="form.reason_id"
                        placeholder="二级原因"
                      >
                        <el-option
                          :key="0"
                          :value="'0'"
                          label="二级原因"
                        ></el-option>
                        <el-option
                          v-for="item in subReasonOption"
                          :key="item.reason_id"
                          :label="item.reason_name"
                          :value="item.reason_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item>
                      <el-select
                        v-model="form.dgid"
                        filterable
                        placeholder="次品组"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in resData.dg_group"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.dpc_id"
                        filterable
                        placeholder="退换货负责人"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in resData.option_dgm"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.refunder_id"
                        filterable
                        placeholder="售后退供员"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in resData.dgm_refunder"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.owe_label"
                        placeholder="代采欠货标签"
                      >
                        <el-option label="全部" value="0"></el-option>
                        <el-option
                          v-for="item in oweLabelOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-input
                        v-model="form.stock_out_create_admin_str"
                        placeholder="扫码出库人"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <el-form-item label="订单生成时间：">
                  <el-date-picker
                    v-model="form.wo_create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="生成时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="退换货生成时间">
                  <el-date-picker
                    v-model="form.stock_out_create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="margin-left: auto"
            type="warning"
            size="small"
            @click="debtTransferToOwe()"
          >
            转欠货
          </el-button>
          <el-button
            type="danger"
            size="small"
            @click="transToBrokenDebts(false)"
          >
            转坏账</el-button
          >
          <el-button type="success" size="small" @click="output">
            导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
              label="选择"
            ></el-table-column>
            <el-table-column
              prop="goods_img"
              label="图片"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    :src="scope.row.main_img"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="woid"
              label="代采单"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="代采单生成时间"
            ></el-table-column>
            <el-table-column align="center" prop="source" label="欠货来源">
              <template #default="{ row }">
                <div>{{ row.source }}</div>
                <div v-if="row.is_transit_formal" style="color: #006cff">
                  {{ row.is_transit_formal }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="right"
              prop="market_name"
              label="市场"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              align="center"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pgname"
              label="代采组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="order_owner_name"
              label="订单负责人"
            ></el-table-column>

            <el-table-column
              prop="dg_group_name"
              label="次品组"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dgm_name"
              label="退换货负责人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="refunder"
              label="售后退供员"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sku"
              label="sku"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="price"
              label="代采单价"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="p_reason_text"
              label="一级原因"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="reson_text"
              label="二级原因"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="source"
              label="来源"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="application_name"
              label="操作人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="application_time"
              label="生成时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="stock_out_create_admin_str"
              label="扫码出库人"
              show-overflow-tooltip
              align="center"
              width="90"
            >
            </el-table-column>
            <el-table-column
              prop="stock_out_create_time"
              label="退换货生成时间"
              show-overflow-tooltip
              align="center"
              width="150"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, sizes, jumper"
            :total="resData.count"
            :page-size="form.page_size"
            :page-sizes="[50, 100]"
            @current-change="handleCurrentChange"
            @size-change="
              (v) => {
                form.page_size = v;
                fetchData();
              }
            "
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog width="30%" center title="提示" :visible.sync="outerVisible">
      <el-dialog
        width="50%"
        title="重选原因"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-form :model="reloadReason">
          <el-form-item label="原因">
            <el-select v-model="reloadReason.p_reasonId" placeholder="一级原因">
              <el-option :key="0" :value="'0'" label="一级原因"></el-option>
              <el-option
                v-for="item in resData.reasonOption"
                :key="item.reason_id"
                :label="item.reason_name"
                :value="item.reason_id"
              >
              </el-option>
            </el-select>
            <el-select v-model="reloadReason.reason_id" placeholder="二级原因">
              <el-option :key="0" :value="'0'" label="二级原因"></el-option>
              <el-option
                v-for="item in subReson"
                :key="item.reason_id"
                :label="item.reason_name"
                :value="item.reason_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="reloadReason.remark" type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="hiddenReload()">取 消</el-button>
          <el-button type="success" @click="transToBrokenDebts(true)">
            确定</el-button
          >
        </div>
      </el-dialog>
      <span>确定要转坏账吗?</span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">取 消</el-button>
        <el-button type="primary" @click="innerVisible = true">
          重选原因</el-button
        >
        <el-button type="success" @click="transToBrokenDebts(true)">
          提交申请</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      outerVisible: false,
      innerVisible: false,
      resData: {
        pgOption: [],
        reasonOption: [],
        list: [],
        count: 0,
        page_size: 100,
      },
      subReasonOption: [],
      supply: {
        list: [],
      },
      form: {
        owe_label: "",
        reason_id: "0",
        p_reason_id: "0",
        wo_create_time: [],
        city: [],
      },
      loading: false,
      tableLoading: false,
      url: "/erp/BrokenDebts/stagnantDebtsList",
      status: -1,
      curPage: 1,
      filterFold: false,
      isAll: false,
      ids: [],
      supplyData: null,
      status: [
        { status: "0", status_value: "全部" },
        { status: "1", status_value: "申请中" },
        { status: "2", status_value: "已通过" },
        { status: "3", status_value: "被驳回" },
      ],
      the_source: [
        {
          key: 0,
          label: "全部",
        },
        {
          key: 1,
          label: "代采欠货",
        },
        {
          key: 2,
          label: "退换欠货",
        },
      ],
      citys: CITY,
      reloadReason: {
        p_reasonId: "0",
        reason_id: "0",
        remark: "",
      },
      oweLabelOptions: [
        {
          label: "订单欠货",
          value: "1",
        },
        {
          label: "在途库存",
          value: "2",
        },
      ],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
    subReson() {
      const child = [];
      const that = this;
      that.reloadReason.reason_id = "0";
      if (that.reloadReason.p_reasonId > 0) {
        for (const key in that.resData.reasonOption) {
          const item = that.resData.reasonOption[key];
          if (that.reloadReason.p_reasonId == item.reason_id) {
            return item.children;
            break;
          }
        }
      } else {
        return [];
      }
    },
  },
  methods: {
    // 坏账分类
    setReson(reason_id) {
      this.subReasonOption = [];
      this.form.reason_id = "0";
      for (const key in this.resData.reasonOption) {
        const item = this.resData.reasonOption[key];
        if (item.reason_id == reason_id) {
          this.subReasonOption = item.children;
        }
      }
    },
    debtTransferToOwe() {
      if (this.ids.length < 1) {
        this.$alert("没有选中项目", "操作错误", {
          confirmButtonText: "确定",
          center: true,
        });
        return;
      }
      this.$confirm("", "确定转回欠货嘛?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
      })
        .then((res) => {
          this.$http
            .post("/erp/BrokenDebts/stagnantDebtTransferToOwe", {
              ids: this.ids,
            })
            .then((res) => {
              if (res.data.code != 200) {
                return this.$message.error(res.data.msg);
              }
              this.$message.success("操作成功");
              this.fetchData();
            });
        })
        .catch((e) => {
          this.$message({
            type: "info",
            message: "取消操作!",
          });
        });
    },
    transToBrokenDebts(trans = false) {
      if (!trans) {
        if (this.ids.length < 1) {
          this.$message.error("没有选择呆账");
          return false;
        }
        this.outerVisible = true;
      } else {
        this.$http
          .post("/erp/BrokenDebts/stagnantDebtTransferToBroken", {
            ids: this.ids,
            reson_id: this.reloadReason.reason_id,
            remark: this.reloadReason.remark,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              return this.$message.error(res.data.msg);
            }
            this.$message.success("操作成功");
            this.outerVisible = false;
            this.innerVisible = false;
            this.reloadReason = {
              reson_id: "0",
              p_reasonId: "0",
              remark: "",
            };
            this.fetchData();
          });
      }
    },
    hiddenReload() {
      this.innerVisible = false;
      this.reloadReason.reason_id = "0";
      this.reloadReason.p_reasonId = "0";
    },
    addColor({ row, column, columnIndex }) {
      if (columnIndex === 17) {
        if (row.status == "已通过") {
          return "blue-cell";
        }
        if (row.status == "被驳回") {
          return "red-cell";
        }
      }
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach((item) => {
        this.ids.push(item.id);
      });
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseStagnantDebts.vue